<template>
    <div>
        <div class="order-kpi-tab" v-if="Order.kpi">
            <div>
                <b-row class="content">
                    <b-col md="9">
                        <div class="d-flex order-kpi-title">
                            <h2>Case Reported</h2>
                            <p>{{Order.kpi.case_reported | formatDate}}</p>
                        </div>
                    </b-col>
                    <b-col md="3">
                        <div class="control">
                            <template v-if="!IsReadOnly">
                                <span v-if="isUpdate && $checkRole(this.$accessModule.order_tabs.kpi_target, 'update')" @click="modalEditKPI">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.708 5.63151C21.098 6.02151 21.098 6.65151 20.708 7.04151L18.878 8.87151L15.128 5.12151L16.958 3.29151C17.1449 3.10426 17.3985 2.99902 17.663 2.99902C17.9276 2.99902 18.1812 3.10426 18.368 3.29151L20.708 5.63151ZM2.99805 20.5015V17.4615C2.99805 17.3215 3.04805 17.2015 3.14805 17.1015L14.058 6.19151L17.808 9.94151L6.88805 20.8515C6.79805 20.9515 6.66805 21.0015 6.53805 21.0015H3.49805C3.21805 21.0015 2.99805 20.7815 2.99805 20.5015Z" fill="#999999"/>
                                    </svg>
                                </span>
                            </template>
                            <b-modal :no-close-on-backdrop="true" id="modal-Assign" title="edit kPI target (Actual)" hide-footer :centered="true" ref="edit-kpiTarget">
                                <b-form>
                                    <b-row>
                                        <b-col md="12">
                                            <gofix-form-dropdown
                                                    label="Type KPI Actual"
                                                    v-model="item.typeKPI"
                                                    :options="options">
                                            </gofix-form-dropdown>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-form-input-date
                                                    desc="dd.mm.yyyy"
                                                    v-model="item.date"
                                                    :disabled="(item.typeKPI && item.typeKPI.value == 'case_reported') ? true : false"
                                                    label="Date">
                                            </gofix-form-input-date>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-form-input-time :disabled="(item.typeKPI && item.typeKPI.value == 'case_reported') ? true : false" label="Time" desc="hh:mm" v-model="item.time"></gofix-form-input-time>
                                        </b-col>
                                    </b-row>
                                </b-form>
                                <b-button-group class="d-block text-right" v-if="isUpdate">
                                    <gofix-button label="MORE" @click="redirect" noBorder dark></gofix-button>
                                    <gofix-button label="SUBMIT" @click="saveKPI" :loading="isAction" noBorder></gofix-button>
                                </b-button-group>
                            </b-modal>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div class="gofixBasicTable">
                <div class="dataList">
                    <gofix-card fullContent classContent="mb-0">
                        <b-table :fields="fields" :items="items" class="orderTable table-filter table-hover table-has-fixed table-has-toprow mb-0" v-bind:class="[filterActive, activeClass ? 'open' : '']" fixed responsive>
                            <template slot="time_taken" slot-scope="data">
                                <span v-b-tooltip.hover :title="data.item.tooltip">{{ data.item.time_taken }}</span>
                            </template>
                            <template slot="kpi" slot-scope="data">
                                <span v-if="data.item.kpi > 0" class="color-red"> {{ data.item.kpi | formatKpi }}</span>
                                <span v-else>{{ data.item.kpi | formatKpi }}</span>
                            </template>
                            <template slot="targeted" slot-scope="row">
                                {{ row.item.targeted | formatDate }}
                            </template>
                            <template slot="actual" slot-scope="row">
                                {{ row.item.actual | formatDate }}
                            </template>
                            <template slot="time_taken" slot-scope="row">
                                {{ row.item.time_taken | formatTimeTaken }}
                            </template>
                        </b-table>
                    </gofix-card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment'
    export default {
        name: 'kpi-target',
        components: {},
        data () {
            return {
                isUpdate: this.$checkRole(this.$accessModule.order, 'update'),
                fields: [
                    {
                        key: 'type',
                        label: '',
                        thClass: 'text-left td-description',
                        tdClass: 'text-left td-description',
                        thStyle: 'width: 300px',
                    },
                    {
                        key: 'targeted',
                        label: 'Targeted',
                        thClass: 'text-center',
                        tdClass: 'text-center',
                    },
                    {
                        key: 'actual',
                        label: 'Actual',
                        thClass: 'text-center',
                        tdClass: 'text-center',
                    },
                    {
                        key: 'time_taken',
                        label: 'Time Taken',
                        thClass: 'text-left',
                        tdClass: 'text-left',
                    },
                    {
                        key: 'kpi',
                        label: 'KPI',
                        thClass: 'text-left',
                        tdClass: 'text-left',
                    },
                ],
                items: [],
                activeClass: false,
                options : [
                    { label: 'Case Reported', value: 'case_reported'},
                    { label: 'Case Acknowledged', value: 'case_ack_actual'},
                    { label: 'WO Acknowledged', value: 'wo_ack_actual'},
                    { label: 'First Time On Site', value: 'case_onsite_actual', },
                    { label: 'WO Completed', value:  'wo_complete_actual'},
                    { label: 'AP Invoice Recieved', value: 'admin_start_actual' },
                    { label: 'Payment Made', value: 'admin_closure_actual' }
                ],
                item : {
                    typeKPI : { label: 'Case Reported', value: 'case_reported'},
                    date : null,
                    time : null
                },
                isAction : false,
            }
        },
        filters: {
            formatTimeTaken(value) {
                if(!value && (value != 0)) return '';
                if(value == 0) return '0 mins';
                if(value > 0 ){
                    if(value < 60)
                        return  '+ '+value + ' second'
                    value =  Math.round( value/60 * 100 + Number.EPSILON ) / 100
                    return  '+ '+value + ' mins'
                }
                value = Math.abs(value);
                if(value < 60)
                    return  '- '+value + ' second'
                value =  Math.round( value/60 * 100 + Number.EPSILON ) / 100
                return  '- '+value + ' mins'
            },
            formatDate(value) {
                if(!value) return '';
                return moment(value).format('DD.MM.YYYY HH:mm');
            },
            formatKpi(value) {
                if(!value && (value != 0)) return '';
                if(value == 0) return '0 mins';
                if(value > 0 ){
                    if(value < 60)
                        return  '+ '+value + ' second'
                    value =  Math.round( value/60 * 100 + Number.EPSILON ) / 100
                    return  '+ '+value + ' mins'
                }
                value = Math.abs(value);
                if(value < 60)
                    return  '- '+value + ' second'
                value =  Math.round( value/60 * 100 + Number.EPSILON ) / 100
                return  '- '+value + ' mins'
            },
        },
        computed: {
            ...mapGetters({
                Order: 'OrderController/Item',
                IsReadOnly: 'OrderController/IsReadOnly',
            })
        },
        watch: {
            "item.typeKPI" : function(val, old){
                if(val){
                    this.item.date = null;
                    this.item.time = "00:00";
                    if(this.Order.kpi[val.value]){
                        let date = this.Order.kpi[val.value];
                        this.item.date = new Date( date )
                        this.item.time = moment(date).format('HH:mm')
                    }
                }
            },
            Order: function(val) {
                if(val && val.kpi && val.sla){
                    this.setDataTable(val.kpi,val.sla);
                }
            },
        },
        created(){
            this.reloadOrder();
        },
        methods: {
            reloadOrder(){
                this.$store.dispatch("OrderController/getItem", this.Order.id)
            },
            redirect() {
                this.$router.push(`/v2/orders/${this.$route.params.id}/kpi-target/1`);
            },
            modalEditKPI() {
                let kpi = this.Order.kpi;
                let date = kpi.case_reported;
                this.item.date = new Date(date)
                this.item.typeKPI = { label: 'Case Reported', value: 'case_reported'}
                this.item.time = moment(date).format('HH:mm')
                this.isAction = false;
                this.$refs['edit-kpiTarget'].show()
            },
            filterActive(){
                this.activeClass = !this.activeClass
            },
            parseIntKpi: function(kpi) {
                return parseInt(kpi);
            },
            saveKPI(){
                if(this.item.typeKPI.value == 'case_reported' && !this.item.date ) {
                    return this.$alertNotification("Case reported required", "danger");
                }

                if(!this.item.date) {
                    return this.$alertNotification("Date is required", "danger");
                }

                let dateTime =  moment(this.item.date).format('YYYY-MM-DD');
                if(this.item.time)
                    dateTime =  dateTime +' '+ this.item.time+':00';
                else
                    dateTime =  dateTime +' '+'00:00:00';
                
                if(this.item.typeKPI.value != 'case_reported' && moment(dateTime).isBefore(this.Order.kpi['case_reported'])) {
                    return this.$alertNotification("The Date must be greater than the reported case date", "danger");
                }

                let data = {
                    [this.item.typeKPI.value] : dateTime
                }

                this.isAction = true;
                this.$store.dispatch("KpiTargetController/updateKPIActual",{ id: this.Order.kpi.id, data : data})
                    .then(response => {
                        this.$refs['edit-kpiTarget'].hide()
                        return this.$alertNotification("Update KPI successfully");
                    })
                    .catch(err => {})
            },
            setDataTable(item,sla){
                let  time_taken_case_ack = null
                let  kpi_case_ack = null

                let  time_taken_case_onsite = null
                let  kpi_case_onsite = null

                let  time_taken_wo_complete = null
                let  kpi_wo_complete = null

                let  time_taken_admin_start = null
                let  kpi_admin_start = null

                let  time_taken_admin_closure = null
                let  kpi_admin_closure = null

                let  time_taken_wo_ack = null
                let  kpi_wo_ack = null
                //if(item.case_ack_actual && moment(item.case_ack_targeted).isBefore(item.case_ack_actual)){
                    if(item.case_ack_actual && item.case_reported){
                        time_taken_case_ack = moment(item.case_ack_actual).diff(moment(item.case_reported), 'second');
                        if(sla) {
                            kpi_case_ack = time_taken_case_ack - sla.reaction_time;
                        }
                    }
                //}

                //if(item.case_onsite_actual && moment(item.case_onsite_targeted).isBefore(item.case_onsite_actual)){
                    if(item.case_ack_actual && item.case_onsite_actual){
                        time_taken_case_onsite = moment(item.case_onsite_actual).diff(moment(item.case_ack_actual), 'second');
                        if(sla) {
                            kpi_case_onsite = time_taken_case_onsite - sla.response_time;
                        }
                    }   
                //}

                //if(item.wo_complete_actual && moment(item.wo_complete_targeted).isBefore(item.wo_complete_actual)){
                    if(item.wo_complete_actual && item.case_ack_actual){
                        time_taken_wo_complete = moment(item.wo_complete_actual).diff(moment(item.case_ack_actual), 'second');
                        if(sla) {
                            kpi_wo_complete = time_taken_wo_complete - sla.rectification_time;
                        }
                    }
                //}

                //if(item.admin_start_actual && moment(item.admin_start_targeted).isBefore(item.admin_start_actual)){
                    if(item.wo_complete_actual && item.admin_start_actual){
                        time_taken_admin_start = moment(item.admin_start_actual).diff(moment(item.wo_complete_actual), 'second');
                        if(sla) {
                            kpi_admin_start = time_taken_admin_start - sla.admin_start;
                        }
                    }
                //}

                //if(item.admin_closure_actual && moment(item.admin_closure_targeted).isBefore(item.admin_closure_actual)){
                    if(item.wo_complete_actual && item.admin_closure_actual){
                        time_taken_admin_closure = moment(item.admin_closure_actual).diff(moment(item.wo_complete_actual), 'second');
                        if(sla) {
                            kpi_admin_closure = time_taken_admin_closure - sla.admin_closure;
                        }
                    }

                //}

                if(item.wo_ack_actual && item.wo_ack_targeted){
                    time_taken_wo_ack = moment(item.wo_ack_actual).diff(moment(item.wo_ack_targeted), 'second');
                    if(sla) {
                        // 5 min
                        kpi_wo_ack = time_taken_wo_ack - 300;
                    }
                }

                this.items = [
                    {
                        type : 'Case Acknowledged',
                        targeted : item.case_ack_targeted,
                        actual :  item.case_ack_actual,
                        time_taken : time_taken_case_ack,
                        kpi : kpi_case_ack,
                        tooltip: 'Reaction Time',
                    },
                    {
                        type : 'WO Acknowledged',
                        targeted : item.wo_ack_targeted,
                        actual :  item.wo_ack_actual,
                        time_taken : time_taken_wo_ack,
                        kpi : kpi_wo_ack,
                        tooltip: 'WO Acknowledged',
                    },
                    {
                        type : 'First Time On Site',
                        targeted : item.case_onsite_targeted,
                        actual :  item.case_onsite_actual,
                        time_taken : time_taken_case_onsite,
                        kpi : kpi_case_onsite,
                        tooltip: 'Response Time',
                    },
                    {
                        type : 'WO Completed',
                        targeted : item.wo_complete_targeted,
                        actual :  item.wo_complete_actual,
                        time_taken : time_taken_wo_complete,
                        kpi : kpi_wo_complete,
                        tooltip: 'Rectification Time',
                    },
                    {
                        type : 'AP Invoice Recieved',
                        targeted : item.admin_start_targeted,
                        actual :  item.admin_start_actual,
                        time_taken : time_taken_admin_start,
                        kpi : kpi_admin_start,
                        tooltip: 'Admin Start',
                    },
                    {
                        type : 'Payment Made',
                        targeted : item.admin_closure_targeted,
                        actual :  item.admin_closure_actual,
                        time_taken : time_taken_admin_closure,
                        kpi : kpi_admin_closure,
                        tooltip: 'Admin Closure',
                    }
                ]
            }
        },
        mounted() {
            this.$root.$on('bv::tooltip::show', bvEvent => {
                bvEvent.relatedTarget.classList.add('tooltip-table');
            })
        }
    }
</script>
